import { useEffect } from 'react';
import { SignUp } from '@clerk/clerk-react';
import {
  AuthPageLayout,
  LeftBrandContainer,
  LeftBrandContent,
  RightContentArea,
} from '../../components/auth/SharedAuthComponents';
import { track } from '../../services/analytics';
import { withMarketingParams } from '../../services/googleAds';

export default function BusinessSignUpPage() {
  useEffect(() => {
    track('signup_started', { signup_type: 'business' });
  }, []);

  return (
    <AuthPageLayout>
      <LeftBrandContainer>
        <LeftBrandContent
          title="Scaling the capabilities of your entire organization"
          subtitle="Comprehensive CPE management for teams and organizations"
        />
      </LeftBrandContainer>
      <RightContentArea>
        <SignUp
          signInUrl="/auth/login"
          forceRedirectUrl={withMarketingParams('/auth/business-setup')}
        />
      </RightContentArea>
    </AuthPageLayout>
  );
}
